<h2>セクション情報</h2>
<div class="block-column">
  <div class="column-list">
    <div class="list-input-title">セクション名</div>
    <div class="list-input-content">
      <input type="text" id="txti_sectionName" readonly style="width:25rem;"
        [maxlength]="25" [(ngModel)]="selectedSectionInfo.sectionTemplateName">
    </div>

    <div></div>
    <div class="list-input-content">
      <label style="width:8rem; text-align:center;">サイズ(mm)</label>
      <label style="width:8rem; text-align:center;">割合(%)</label>
    </div>

    <div class="list-input-title">基点X(mm)</div>
    <div class="list-input-content">
      <input type="text" id="txti_sectionPosX" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.positionX">
      <input type="text" id="txti_sectionPercentPosX" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.percentPositionXDisplay">
    </div>

    <div class="list-input-title">基点Y(mm)</div>
    <div class="list-input-content">
      <input type="text" id="txti_sectionPosY" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.positionY">
      <input type="text" style="width:8rem;"
        id="txti_sectionPercentPosY" plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5"
        readonly [(ngModel)]="selectedSectionInfo.percentPositionYDisplay">
    </div>

    <div class="list-input-title" >セクション領域幅(mm)</div>
    <div class="list-input-content">
      <input type="text" id="txti_sectionWidth" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.width">
      <input type="text" id="txti_sectionPercentWidth" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.percentWidthDisplay">
    </div>

    <div class="list-input-title">セクション領域高さ(mm)</div>
    <div class="list-input-content">
      <input type="text" id="txti_sectionHeight" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.height">
      <input type="text" id="txti_sectionPercentHeight" style="width:8rem;"
        plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="5" readonly
        [(ngModel)]="selectedSectionInfo.percentHeightDisplay">
    </div>

    <div class="list-input-title">グリッド</div>
    <div class="list-input-content">
      <label>横</label>
      <wj-input-number class="numeric-stepper"
        #SectionDivW id="ns_sectionDivW" [min]="1" [max]="99"
        [showSpinner]="true" [step]="1" [disabled]="true" [value]="1" [isRequired]="false"
        [(ngModel)]="selectedSectionInfo.divW">
      </wj-input-number>
      <label>×</label>
      <label>縦</label>
      <wj-input-number class="numeric-stepper"
        #SectionDivH id="ns_sectionDivH" [min]="1" [max]="99"
        [showSpinner]="true" [step]="1" [disabled]="true" [value]="1" [isRequired]="false"
        [(ngModel)]="selectedSectionInfo.divH">
      </wj-input-number>
    </div>
  </div>
  <button class="btn-tartiary warning"
    id="btn_DeleteSection" (click)="clickDeleteSection.emit()">セクションを削除</button>
</div>